import Box from '@mui/material/Box'
import { styled } from '@mui/material'
import Button from '@mui/material/Button'

const SlideMenuAccountBox = styled(Box)(({ theme }) => ({
	borderBottom: `2px solid ${theme.palette.grey[200]}`,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	overflow: 'hidden',
}))

const SlideMenuAccountOpenMenuSmallBtn = styled(Button)(({ theme }) => ({
	padding: '0 0 0 0.5rem',
	minWidth: 'unset',
	textTransform: 'uppercase',
	color: theme.palette.text.secondary,
	fontSize: '1rem',
	fontWeight: 600,
	justifyContent: 'flex-start',
	'& .MuiButton-endIcon': { marginLeft: 0 },
	'+ p': {
		color: theme.palette.text.secondary,
		fontSize: '0.9375rem',
		fontFamily: 'Gilroy, sans-serif',
		paddingLeft: '0.5rem',
	},
}))

export { SlideMenuAccountBox, SlideMenuAccountOpenMenuSmallBtn }
